module.exports = __webpack_public_path__ + "static/barda_preview-89b022ee5bfb129a01227f6e33a99976.png";